import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RoutingModule } from './RoutingModule';
import { HttpClientModule } from '@angular/common/http';
import { MainComponent } from './components/MainComponent';
import { LoginModule } from './components/login/Login';
import { AppModule } from './components/app/App';
import { HomeModule } from './components/app/home/Home';
import { PasswordRecoveryModule } from './components/passwordRecovery/PasswordRecovery';
import { LinkSentModule } from './components/passwordRecovery/LinkSent';
import { ChangePasswordModule } from './components/passwordRecovery/ChangePassword';
import { InvalidRequestModule } from './components/passwordRecovery/InvalidRequest';
import { SuccessfulKeyChangeModule } from './components/passwordRecovery/SuccessfulKeyChange';
import { SettingModule } from './components/app/home/Setting';
import { ErrorInterceptor } from './providers/http/ErrorInterceptor';
import * as moment from 'moment';
import { LobbyModule } from 'components/lobby/LobbyModule';
import { ProfileModule } from 'components/support/companies/profile/ProfileModule';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

moment.locale('es');


@NgModule({
    declarations: [
        MainComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        LoginModule,
        AppModule,
        LobbyModule,
        ProfileModule,
        PasswordRecoveryModule,
        LinkSentModule,
        ChangePasswordModule,
        InvalidRequestModule,
        SuccessfulKeyChangeModule,
        SettingModule,
        RoutingModule,
    ],
    providers: [
        ErrorInterceptor,
        /**
         * se usa para acceder a las rutas del proyecto
         * por medio de las url.
         */
        { provide: LocationStrategy, useClass: HashLocationStrategy }
    ],
    bootstrap: [MainComponent]
})
export class MainModule { }
